export const CARRIER_UPS = 'ups';
export const CARRIER_USPS = 'usps';
export const CARRIER_DHL = 'dhl';
export const CARRIER_FEDEX = 'fedex';
export const CARRIER_NONE = 'none';

export const CarrierDisplayName = {
  [CARRIER_NONE]: 'None',
  [CARRIER_UPS]: 'UPS',
  [CARRIER_USPS]: 'USPS',
  [CARRIER_DHL]: 'DHL',
  [CARRIER_FEDEX]: 'FedEx',
};
